module.exports = __webpack_public_path__ + "img/46.991be5e8.jpg";